"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analysis = exports.questions = void 0;

var _flatten = _interopRequireDefault(require("lodash/flatten"));

var _screeners = require("../../screeners");

var _utils = require("../../screeners/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var surveyscreeners = [// screeners.RTWDEMOG,
_utils.screeners.PHQ9, _utils.screeners.GAD7, _utils.screeners.PSS4RTW, _utils.screeners.WHO5RTW, _utils.screeners.WRKBTY, _utils.screeners.SICK, // screeners.HRQOL,
_utils.screeners.ECOVAL // screeners.CSQ8,
// screeners.RTW_FEEDBACK
];
var questions = (0, _screeners.expandscreeners)([].concat(surveyscreeners));
exports.questions = questions;

var analysis = function analysis(answers, numeric) {
  if (!answers) return null;
  var results = {};
  results.scales = {};
  results.humanReadable = {};
  surveyscreeners.forEach(function (battery) {
    var batteryResults = (0, _screeners.extractResults)(questions, (0, _flatten["default"])(Object.values(answers)), battery);
    var scales = (0, _screeners.getScalesByBatteryId)(battery);

    if (scales) {
      results.scales = Object.assign(results.scales, scales);
    }

    var batteryHumanReadable = batteryResults.humanReadable;
    delete batteryResults.humanReadable;
    results = Object.assign(results, batteryResults);
    results.humanReadable = Object.assign(results.humanReadable, batteryHumanReadable);
    results;
  });
  questions.forEach(function (q, i) {
    if (!q.key) return;

    if (numeric) {
      results[q.key] = answers[q.batteryId][i];
    } else {
      results[q.key] = q.eval(answers[q.batteryId][i], q);
      results.humanReadable[q.prompt] = q.eval(answers[q.batteryId][i], q);
    }
  });
  return results;
};

exports.analysis = analysis;